const FETCH_GAMES = 'FETCH_GAMES'
const GET_DETAIL = 'GET_DETAIL'
const FETCH_SEARCHED = 'FETCH_SEARCHED'
const CLEAR_SEARCHED = 'CLEAR_SEARCHED'

export { FETCH_GAMES, GET_DETAIL, FETCH_SEARCHED, CLEAR_SEARCHED }
